import store_consultation from '@/store/mods/consultations/consultations'
import $ from 'jquery'

export default {
    name: 'view-traitement',
    components: {
        
    },
    props: {
        consultation_id: Number,
        toggler: Number
    },
    data() {
        return {
            traitement_en_cours: [],
            is_empty: false,
            is_loading: true,
            is_error: false,
            action_toggler: 0,
            soin_justif: '',
            preuve: null,
            viewing_content: 'view-traitement',

            file_type: '',
            assets_url: ''
        }
    },

    watch: {
        toggler() {
            this.getListeTraitementEnCours()
        },
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        getListeTraitementEnCours() {
            this.is_loading = true

            const data = {
                consultation_id: this.consultation_id,
            }
            store_consultation.getTraitementEnCours(data).then((response) => {
                this.traitement_en_cours = response
                if (this.traitement_en_cours.length == 0) {
                    this.is_empty = true 
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        dropContent(selector) {
            console.log(selector);
            var el = document.getElementById(selector)

            // Check if element has class show
            if ($('#'+selector).hasClass("show")) {
                el.classList.remove('show')
            } else {
                el.classList.add('show')
            }
        },

        viewJustif(justif) {
            this.viewing_content = 'view-justif'
            this.soin_justif = justif

            setTimeout(() => {
                $('.view-treatment').modal('show')
            }, 200);
        },

        viewProve(proof) {
            this.viewing_content = 'view-proof'
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.preuve = proof

            if (this.preuve != null) {
                this.assets_url = this.assets_path+'/files/consultation_contents'
                this.file_type = this.getFileType(this.preuve)
            }

            setTimeout(() => {
                $('.view-treatment').modal('show')
            }, 200);
        },
    }
}